export enum FIELDS {
  HAS_ADVERSE_CREDIT = 'hasAdverseCredit',
  APPLICANTS = 'applicants',
  APPLICATION_TYPE = 'applicationType',
  ACCOUNT_NAME = 'accountName',
  ACCOUNT_NUMBER = 'accountNumber',
  ACTUAL_PROPERTY_VALUE = 'actualPropertyValue',
  BANK_OR_BUILDING_SOCIETY_NAME = 'bankOrBuildingSocietyName',
  ADDITIONAL_DETAILS = 'additionalDetails',
  CREDIT_POLICY_EXEMPTION_RATIONALE = 'creditPolicyExemptionRationale',
  CURRENT_MORTGAGE_PROVIDER = 'currentMortgageProvider',
  APPLICATION_DATE = 'applicationDate',
  DEBT_TO_INCOME = 'debtToIncome',
  DELPHI_CREDIT_REFERENCE_NUMBER = 'delphiCreditReferenceNumber',
  DELPHI_DATE_OF_SEARCH = 'delphiDateOfSearch',
  DELPHI_SCORE = 'delphiScore',
  DEPOSIT_SOURCE_BUILDERS = 'depositSourceBuilders',
  DEPOSIT_SOURCE_DETAILS = 'depositSourceDetails',
  DEPOSIT_SOURCE_EQUITY_FROM_SALE = 'depositSourceEquityFromSale',
  DEPOSIT_SOURCE_GIFTS = 'depositSourceGifts',
  DEPOSIT_SOURCE_OTHER = 'depositSourceOther',
  DEPOSIT_SOURCE_SAVINGS = 'depositSourceSavings',
  ESTIMATED_PROPERTY_VALUE = 'estimatedPropertyValue',
  CASE_ID = 'caseId',
  GROSS_LOAN = 'grossLoan',
  NET_LOAN = 'netLoan',
  LTV = 'ltv',
  ID = 'id',
  CREATED_BY = 'createdBy',
  UPDATED_AT = 'updatedAt',
  IS_BUY_TO_LET = 'isBuyToLet',
  IS_CREDIT_POLICY_EXEMPTION = 'isCreditPolicyExemption',
  IS_FIRST_TIME_BUYER = 'isFirstTimeBuyer',
  IS_PRIVATE_SALE = 'isPrivateSale',
  LOAN_AMOUNT_PURCHASE = 'loanAmountPurchase',
  LOAN_AMOUNT_REMORTGAGE = 'loanAmountRemortgage',
  LOAN_ASSISTING_OTHERS = 'loanAssistingOthers',
  LOAN_DEBT_CONSOLIDATION = 'loanDebtConsolidation',
  LOAN_DISCRETIONARY_SPEND = 'loanDiscretionarySpend',
  LOAN_HOME_IMPROVEMENTS = 'loanHomeImprovements',
  LOAN_OTHER_PURPOSES = 'loanOtherPurposes',
  MONTHLY_BASIC_SPEND = 'monthlyBasicSpend',
  NUMBER_OF_APPLICANTS = 'numberOfApplicants',
  OWNER = 'owner',
  PEPPER_PURPOSE_OF_THE_LOAN = 'pepperPurposeOfTheLoan',
  POSTCODE = 'postcode',
  PRODUCT_CODE = 'productCode',
  PRODUCT_TIER = 'productTier',
  PRODUCT_FEE = 'productFee',
  PRODUCT_FEE_PAYMENT_METHOD = 'productFeePaymentMethod',
  PRODUCT_FIXED_INTEREST_RATE = 'productFixedInterestRate',
  PRODUCT_FIXED_TERM = 'productFixedTerm',
  PRODUCT_REVERSION_RATE = 'productReversionRate',
  PRODUCT_REPAYMENT_TYPE = 'productRepaymentType',
  PROPERTY_PURCHASE_PRICE = 'propertyPurchasePrice',
  PURPOSE_OF_CAPITAL_RAISE = 'purposeOfCapitalRaise',
  PURPOSE_OF_THE_LOAN = 'purposeOfTheLoan',
  RATIONALE = 'rationale',
  OFFER_PACK_URL = 'offerPackUrl',
  SORT_CODE = 'sortCode',
  SOURCE_OF_DEPOSIT = 'sourceOfDeposit',
  STAGE = 'stage',
  STATUS = 'status',
  IS_ON_HOLD_STATUS = 'isOnHoldStatus',
  IS_APPLICATION_APPROVED_AUTHORITY_LEVELS = 'isApprovedWithAuthorityLevels',
  IS_CALL_CARRIED_ALL_APPLICANTS = 'isPreOfferCarriedOutForApplicants',
  IS_PEPPER_UPLOAD_APPROVED = 'isPepperUploadApproved',
  VALUATION_FEE_AMOUNT = 'valuationFeeAmount',
  VALUATION_FEE_PAYMENT = 'valuationFeePayment',
  RE_INSPECTION_FEE = 'reinspectionFee',
  ADVISER_NAME = 'adviserName',
  ADVISER_FEE = 'adviserFee',
  ADVISER_PHONE = 'adviserPhone',
  ADVISER_EMAIL = 'adviserEmail',
  STANDARD_COMMISSION_TERMS = 'standardCommissionTerms',
  ENHANCED_COMMISSION_TERMS = 'enhancedCommissionTerms',
  ONGOING_COMMISSION_TERMS_UPFRONT_FEE = 'ongoingCommissionTermsUpfrontFee',
  ONGOING_COMMISSION_TERMS_ONGOING_FEE = 'ongoingCommissionTermsOngoingFee',
  CLUB_NAME = 'clubName',
  SUBMISSION_ROUTE = 'submissionRoute',
  COMMISSION_PAID_TO = 'commissionPaidTo',
  NETWORK_NAME = 'networkName',
  FIRM_NAME = 'firmName',
  FIRM_FCA_NUMBER = 'firmFcaNumber',
  FIRM_ADDRESS = 'firmAddress',
  NETWORK_FCA_NUMBER = 'networkFcaNumber',
  ADVISER_FEE_LAST_PAYMENT_MOMENT = 'adviserFeeLastPaymentMoment',
  UPFRONT_COMMISSION_AMOUNT = 'upfrontCommissionAmount',
  ONGOING_COMMISSION_AMOUNT = 'ongoingCommissionAmount',
  HAS_MARKETING_EMAIL = 'hasMarketingEmail',
  HAS_MARKETING_SMS = 'hasMarketingSms',
  HAS_MARKETING_PHONE = 'hasMarketingPhone',
  HAS_MARKETING_POST = 'hasMarketingPost',
  TERM_LENGTH = 'termLength',
  PRODUCT_TYPE = 'productType',
  PACKAGER_FEE = 'packagerFee',
  PACKAGER_FEE_LAST_PAYMENT_MOMENT = 'packagerFeeLastPaymentMoment',

  APPLICANT_TITLE = 'title',
  APPLICANT_NAME = 'name',
  APPLICANT_SURNAME = 'surname',
  APPLICANT_MIDDLE_NAME = 'middleName',
  APPLICANT_PREVIOUS_NAME = 'previousName',
  APPLICANT_PROOF_OF_ID = 'proofOfId',
  APPLICANT_DATE_OF_BIRTH = 'dateOfBirth',
  APPLICANT_AGE = 'age',
  APPLICANT_PLANNED_RETIREMENT_AGE = 'plannedRetirementAge',
  APPLICANT_GENDER = 'gender',
  APPLICANT_MARITAL_STATUS = 'maritalStatus',
  APPLICANT_CURRENT_ADDRESS = 'currentAddress',
  APPLICANT_PREVIOUS_ADDRESSES = 'previousAddresses',
  APPLICANT_NATIONALITY = 'nationality',
  APPLICANT_IS_UK_RESIDENT = 'isUkResident',
  APPLICANT_HAS_INDEFINITE_LEAVE_TO_REMAIN = 'hasIndefiniteLeaveToRemain',
  APPLICANT_PHONE_HOME = 'phoneHome',
  APPLICANT_IS_PHONE_HOME_PEPPER = 'isPhoneHomePepper',
  APPLICANT_PHONE_MOBILE = 'phoneMobile',
  APPLICANT_IS_PHONE_MOBILE_PEPPER = 'isPhoneMobilePepper',
  APPLICANT_PHONE_WORK = 'phoneWork',
  APPLICANT_IS_PHONE_WORK_PEPPER = 'isPhoneWorkPepper',
  APPLICANT_EMAIL = 'email',
  APPLICANT_IS_EMAIL_PEPPER = 'isEmailPepper',
  APPLICANT_ADDITIONAL_EMAIL = 'additionalEmail',
  APPLICANT_ADDITIONAL_EMAIL_PEPPER = 'isAdditionalEmailPepper',
  APPLICANT_IS_CRIMINAL = 'isCriminal',
  APPLICANT_CRIMINAL_CONVICTIONS_DETAIL = 'criminalConvictionsDetails',
  APPLICANT_HAS_ADVERSE_CREDIT = 'hasAdverseCredit',
  APPLICANT_ADVERSE_CREDIT_DETAILS = 'adverseCreditDetails',
  APPLICANT_BANKRUPTCY_AMOUNT = 'bankruptcyAmount',
  APPLICANT_BANKRUPTCY_LATEST_DATE = 'bankruptcyLatestDate',
  APPLICANT_CCJ_AMOUNT = 'ccjAmount',
  APPLICANT_CCJ_LATEST_DATE = 'ccjLatestDate',
  APPLICANT_DEFAULT_AMOUNT = 'defaultAmount',
  APPLICANT_DEFAULT_LAST_DATE = 'defaultLatestDate',
  APPLICANT_MORTGAGE_ARREARS_AMOUNT = 'mortgageArrearsAmount',
  APPLICANT_MORTGAGE_ARREARS_LATEST_DATE = 'mortgageArrearsLatestDate',

  APPLICANT_POWER_OF_ATTORNEY = 'powerOfAttorney',

  APPLICANT_POWER_OF_ATTORNEY_NAME = 'name',
  APPLICANT_POWER_OF_ATTORNEY_HAS_CUSTOMISED_SERVICES = 'hasCustomisedServices',
  APPLICANT_POWER_OF_ATTORNEY_CUSTOMISED_SERVICES_REQUEST = 'customisedServicesRequest',
  APPLICANT_POWER_OF_ATTORNEY_PHONE_NUMBER = 'phoneNumber',
  APPLICANT_POWER_OF_ATTORNEY_EMAIL = 'email',
  APPLICANT_POWER_OF_ATTORNEY_POSTCODE = 'postcode',
  APPLICANT_POWER_OF_ATTORNEY_FLAT_NUMBER = 'flatNumber',
  APPLICANT_POWER_OF_ATTORNEY_BUILDING_NAME = 'buildingName',
  APPLICANT_POWER_OF_ATTORNEY_BUILDING_NUMBER = 'buildingNumber',
  APPLICANT_POWER_OF_ATTORNEY_STREET = 'street',
  APPLICANT_POWER_OF_ATTORNEY_CITY = 'city',

  APPLICANT_ADDRESS_FLAT_NUMBER = 'flatNumber',
  APPLICANT_ADDRESS_BUILDING_NAME = 'buildingName',
  APPLICANT_ADDRESS_BUILDING_NUMBER = 'buildingNumber',
  APPLICANT_ADDRESS_STREET = 'street',
  APPLICANT_ADDRESS_CITY = 'city',
  APPLICANT_ADDRESS_POSTCODE = 'postcode',
  APPLICANT_ADDRESS_MOVED_IN_DATE = 'movedInDate',
  APPLICANT_ADDRESS_PROOF_OF_ADDRESS = 'proofOfAddress',
  APPLICANT_NUMBER_OF_DEPENDANTS = 'numberOfDependants',

  EXPENDITURES_PREFIX = 'liabilities',
  EXPENDITURE_ID = 'id',
  EXPENDITURE_TYPE = 'type',
  EXPENDITURE_CREDIT_LIMIT = 'creditLimit',
  EXPENDITURE_BALANCE = 'balance',
  EXPENDITURE_DESCRIPTION = 'description',
  EXPENDITURE_AMOUNT = 'amount',
  EXPENDITURE_FREQUENCY = 'frequency',
  EXPENDITURE_END_DATE = 'endDate',
  EXPENDITURE_TOTAL_NUMBER_OF_PROPERTIES = 'totalNumberOfProperties',
  EXPENDITURE_WILL_BE_CLEARED_BEFORE_LOAN = 'willBeClearedBeforeLoan',
  EXPENDITURE_WILL_BE_CLEARED_BY_LOAN = 'willBeClearedByLoan',
  COMMITMENT_TO_BE_CLEARED = 'commitmentToBeCleared',
  COMMITMENT_REMAINING = 'commitmentRemaining',
  MONTHLY_AMOUNT = 'monthlyAmount',
  BALANCE = 'balance',
  ASSETS_PREFIX = 'assets',
  ASSETS_ID = 'id',
  ASSETS_TYPE = 'type',
  ASSETS_VALUE = 'value',
  ASSETS_DESCRIPTION = 'description',
  ASSETS_WILL_BE_USED_TO_PAY_LOAN = 'willBeUsedToPayLoan',
  ASSETS_OUTSTANDING_MORTGAGE_BALANCE = 'outstandingMortgageBalance',
  ASSETS_PROPERTY_POSTCODE = 'postcode',
  ASSETS_PROPERTY_CITY = 'city',
  ASSETS_PROPERTY_FLAT_NUMBER = 'flatNumber',
  ASSETS_PROPERTY_BUILDING_NAME = 'buildingName',
  ASSETS_PROPERTY_BUILDING_NUMBER = 'buildingNumber',
  ASSETS_PROPERTY_STREET = 'street',

  CURRENT_STATE_PENSION = 'currentStatePension',
  CURRENT_DB_NAME_OF_SCHEME = 'currentDbNameOfScheme',
  CURRENT_DB_ANNUAL_INCOME = 'currentDbAnnualIncome',
  CURRENT_DB_PERCENT_PASSED_ON_DEATH = 'currentDbPercentPassedOnDeath',
  CURRENT_DC_NAME_OF_SCHEME = 'currentDcNameOfScheme',
  CURRENT_DC_CURRENT_VALUE = 'currentDcCurrentValue',
  CURRENT_DC_PERCENT_PASSED_ON_DEATH = 'currentDcPercentPassedOnDeath',
  CURRENT_DC_ANNUAL_INCOME_DRAWN = 'currentDcAnnualIncomeDrawn',
  CURRENT_ANNUITY_NAME_OF_ANNUITY_PROVIDER = 'currentAnnuityNameOfAnnuityProvider',
  CURRENT_ANNUITY_GROSS_ANNUAL_INCOME = 'currentAnnuityGrossAnnualIncome',
  CURRENT_ANNUITY_PERCENT_PASSED_ON_DEATH = 'currentAnnuityPercentPassedOnDeath',

  FUTURE_STATE_PENSION = 'futureStatePension',
  FUTURE_PENSION_DEFINED_BENEFITS_PREFIX = 'futurePensionDefinedBenefits',
  FUTURE_PENSION_DEFINED_CONTRIBUTIONS_PREFIX = 'futurePensionDefinedContributions',
  NAME_OF_SCHEME = 'nameOfScheme',
  ANNUAL_INCOME = 'annualIncome',
  CURRENT_VALUE = 'currentValue',
  START_DATE = 'startDate',
  PERCENTAGE_VALUE_OF_PASSED_ON_DEATH = 'percentageValueOfPassedOnDeath',
  FUTURE_ANNUAL_INCOME_DRAWN = 'annualIncomeDrawn',
  FUTURE_PENSION_REPAYMENT_LUMP_SUM = 'repaymentLumpSum',
  ONGOING_MONTHLY_CONTRIBUTIONS = 'ongoingMonthlyContributions',
  LUMP_SUM_DRAWDOWN = 'lumpSumDrawdown',
  REPAYMENT_LUMP_SUM = 'repaymentLumpSum',
  USE_OF_FUND = 'useOfFund',
  FUTURE_ANNUITY_PREFIX = 'futurePensionAnnuity',
  FUTURE_ANNUITY_NAME_OF_ANNUITY_PROVIDER = 'annuityProvider',
  FUTURE_ANNUITY_GROSS_ANNUAL_INCOME = 'annuityGrossIncome',
  FUTURE_ANNUITY_PERCENT_PASSED_ON_DEATH = 'annuityPercentageToOtherInCaseOfDeath',

  APPLICANT_EMPLOYMENT_STATUS = 'employmentStatus',
  APPLICANT_EMPLOYED_JOB_TITLE = 'employedJobTitle',
  APPLICANT_EMPLOYED_COMPANY_NAME = 'employedCompanyName',
  APPLICANT_EMPLOYED_COMPANY_ADDRESS = 'employedCompanyAddress',
  APPLICANT_EMPLOYED_NATURE = 'employedNature',
  APPLICANT_EMPLOYED_START_DATE = 'employedStartDate',
  APPLICANT_EMPLOYED_ANTICIPATED_AGE = 'employedAnticipatedAge',
  APPLICANT_SELF_EMPLOYED_JOB_TITLE = 'selfEmployedJobTitle',
  APPLICANT_SELF_EMPLOYED_COMPANY_NAME = 'selfEmployedCompanyName',
  APPLICANT_SELF_EMPLOYED_COMPANY_ADDRESS = 'selfEmployedCompanyAddress',
  APPLICANT_SELF_EMPLOYED_NATURE = 'selfEmployedNature',
  APPLICANT_SELF_EMPLOYED_START_DATE = 'selfEmployedStartDate',
  APPLICANT_BUSINESS_TYPE = 'businessType',
  APPLICANT_SELF_EMPLOYED_ANTICIPATED_AGE = 'selfEmployedAnticipatedAge',

  PROPERTY_FLAT_NUMBER = 'flatNumber',
  PROPERTY_BUILDING_NAME = 'buildingName',
  PROPERTY_BUILDING_NUMBER = 'buildingNumber',
  PROPERTY_STREET = 'street',
  PROPERTY_CITY = 'city',
  PROPERTY_POSTCODE = 'postcode',
  PROPERTY_HAS_OCCUPANTS_OVER17 = 'hasOccupantsOver17',
  PROPERTY_IS_PRIMARY_HOME = 'isPrimaryHome',
  PROPERTY_TYPE = 'type',
  PROPERTY_FLOOR_NUMBER = 'floorNumber',
  PROPERTY_NUMBER_OF_FLOORS_IN_THE_BUILDING = 'numberOfFloorsInTheBuilding',
  PROPERTY_HAS_LIFT_ACCESS = 'hasLiftAccess',
  PROPERTY_TENURE_TYPE = 'tenureType',
  PROPERTY_REMAINING_YEARS = 'remainingYears',
  PROPERTY_IS_EX_LOCAL_AUTHORITY = 'isExLocalAuthority',
  PROPERTY_IS_RETIREMENT_HOME = 'isRetirementHome',
  PROPERTY_IS_RESTRICTED_COVENANT = 'isRestrictedCovenant',
  PROPERTY_IS_ABOVE_COMMERCIAL_PREMISES = 'isAboveCommercialPremises',
  PROPERTY_COMMERCIAL_PREMISES_DETAILS = 'commercialPremisesDetails',
  PROPERTY_HAS_COMMERCIAL_USAGE_ABOVE25_PERCENT = 'hasCommercialUsageAbove25Percent',
  PROPERTY_COMMERCIAL_USAGE_DETAILS = 'commercialUsageDetails',
  PROPERTY_NUMBER_OF_KITCHENS = 'numberOfKitchens',
  PROPERTY_NUMBER_OF_BEDROOMS = 'numberOfBedrooms',
  PROPERTY_HAS_AGRICULTURAL_RESTRICTIONS = 'hasAgriculturalRestrictions',
  PROPERTY_PROPERTY_YEAR_BUILT = 'propertyYearBuilt',
  PROPERTY_WARRANTY_PROVIDER = 'warrantyProvider',
  PROPERTY_IS_PROPERTY_NEW_BUILD = 'isPropertyNewBuild',
  PROPERTY_PROPERTY_CONSTRUCTION = 'propertyConstruction',
  PROPERTY_PROPERTY_DETAILS = 'propertyDetails',
  PROPERTY_INSTRUCTION_DATE = 'instructionDate',
  PROPERTY_INSPECTION_DATE = 'inspectionDate',
  PROPERTY_VALUATION_TYPE = 'valuationType',
  PROPERTY_HAS_SPECIALIST_REPORT = 'hasSpecialistReport',
  PROPERTY_TITLE_NUMBER = 'titleNumber',
  PROPERTY_ESTIMATED_PROPERTY_VALUE = 'estimatedPropertyValue',
  PROPERTY_PROPERTY_PURCHASE_PRICE = 'propertyPurchasePrice',
  PROPERTY_ACTUAL_PROPERTY_VALUE = 'actualPropertyValue',
  PROPERTY_OCCUPANTS_PREFIX = 'occupants',
  PROPERTY_OCCUPANT_FULLNAME = 'fullName',
  PROPERTY_OCCUPANT_DATE_OF_BIRTH = 'dateOfBirth',

  ASSURANCE_POLICIES_PREFIX = 'assurancePolicies',
  ASSURANCE_POLICY_EXPIRY_DATE = 'expiryDate',
  ASSURANCE_POLICY_ASSURED_PERSON = 'assuredPerson',
  ASSURANCE_POLICY_TYPE = 'type',
  ASSURANCE_POLICY_PAYMENTS_PER_ANNUM = 'paymentsPerAnnum',
  ASSURANCE_POLICY_BASIS_OF_COVER = 'basisOfCover',
  ASSURANCE_POLICY_INSURANCE_LUMP_SUM = 'insuranceLumpSum',
  ASSURANCE_POLICY_MONTHLY_PAYMENT = 'monthlyPremium',
  ASSURANCE_POLICY_MORTGAGE_MONTHLY_PAYMENTS = 'mortgageMonthlyPayments',

  SOLICITOR_PREFIX = 'solicitor',
  SOLICITOR_NAME = 'solicitorName',
  SOLICITOR_CONTACT_NUMBER = 'solicitorContactNumber',
  SOLICITOR_EMAIL = 'solicitorEmail',
  SOLICITOR_FLAT_NUMBER = 'solicitorFlatNumber',
  SOLICITOR_BUILDING_NUMBER = 'solicitorBuildingNumber',
  SOLICITOR_BUILDING_NAME = 'solicitorBuildingName',
  SOLICITOR_STREET = 'solicitorStreet',
  SOLICITOR_ADDRESS_CITY = 'solicitorCity',
  SOLICITOR_ADDRESS_POSTCODE = 'solicitorPostcode',

  FCA_LOAN_PURPOSE = 'fcaLoanPurpose',
  OUTSTANDING_MORTGAGE_AMOUNT = 'outstandingMortgageAmount',
  SOURCE_OF_FUNDS_TO_CLEAR_OUTSTANDING_MORTGAGE = 'sourceOfFundsToClearOutstandingMortgage',
  EXISTING_MORTGAGE_STATUS = 'existingMortgageStatus',
  ANNUAL_COUNCIL_TAX = 'annualCouncilTax',
  ANNUAL_GROUND_RENT = 'annualGroundRent',

  ADMIN_PREFIX = 'admin',
  ADMIN_OFFER_DATE = 'offerDate',
  ADMIN_COT_REC_DATE = 'cotRecDate',
  ADMIN_FUNDS_REQ_DATE = 'fundsReqDate',
  ADMIN_EXPECTED_COMPLETION_DATE = 'expectedCompletionDate',
  ADMIN_COMPLETION_DATE = 'completionDate',
  ADMIN_PEPPER_UPLOAD_DATE = 'pepperUploadDate',
  ADMIN_PEPPER_ACCOUNT_ID = 'pepperAccountId',
  ADMIN_ORIGINATOR_ID = 'originatorId',
  ADMIN_DECLINE_DATE = 'declineDate',
  ADMIN_SWAP_COST = 'swapCost',
  ADMIN_EXPECTED_MATURITY = 'expectedMaturity',

  DELEGATED_AUTHORITY_LEVEL = 'delegatedAuthorityLevel',
  INITIAL_ASSESSMENT_BY = 'initialAssessmentBy',
  INITIAL_ASSESSMENT_DATE = 'assessmentDate',
  INITIAL_ASSESSMENT_APPROVED_BY = 'initialAssessmentApprovedBy',
  INITIAL_ASSESSMENT_APPROVED_DATE = 'initialAssessmentApprovedDate',
  UW_RECOMMENDATION = 'uwRecommendation',
  UW_SPECIAL_CONDITIONS = 'uwSpecialConditions',

  AFT_PREFIX = 'affordabilityResults',
  AFT_STAGE = 'stage',
  AFT_INCOME = 'income',
  AFT_BUFFER = 'buffer',
  AFT_LIVING_COSTS = 'livingCosts',
  AFT_NET_CASH_FLOW = 'netCashFlow',
  AFT_MAX_LOAN_POSSIBLE = 'maxLoanPossible',
}

export enum INPUTS {
  TEXT = 'text',
  TEXTAREA = 'textArea',
  CHECKBOX = 'checkbox',
  SELECT = 'select',
}

export type Field = {
  name: string;
  label: string;
  prefix?: string;
};

export type EditedField = {
  field: Field;
  value: any;
  fullPath: string;
};

export type AvailableInputs = INPUTS.TEXT | INPUTS.CHECKBOX | INPUTS.SELECT | INPUTS.TEXTAREA;

const fields = {
  [FIELDS.APPLICATION_TYPE]: { name: FIELDS.APPLICATION_TYPE, label: 'Application type' },
  [FIELDS.CASE_ID]: { name: FIELDS.CASE_ID, label: 'Case ID' },
  [FIELDS.GROSS_LOAN]: { name: FIELDS.GROSS_LOAN, label: 'Gross Loan' },
  [FIELDS.NET_LOAN]: { name: FIELDS.NET_LOAN, label: 'Net Loan' },
  [FIELDS.LTV]: { name: FIELDS.LTV, label: 'LTV' },
  [FIELDS.ACCOUNT_NAME]: { name: FIELDS.ACCOUNT_NAME, label: 'Account Name' },
  [FIELDS.ACCOUNT_NUMBER]: { name: FIELDS.ACCOUNT_NUMBER, label: 'Account Number' },
  [FIELDS.ACTUAL_PROPERTY_VALUE]: { name: FIELDS.ACTUAL_PROPERTY_VALUE, label: 'Actual Property Value' },
  [FIELDS.BANK_OR_BUILDING_SOCIETY_NAME]: {
    name: FIELDS.BANK_OR_BUILDING_SOCIETY_NAME,
    label: 'Bank/Building Society',
  },
  [FIELDS.ADDITIONAL_DETAILS]: {
    name: FIELDS.ADDITIONAL_DETAILS,
    label: 'Additional details',
  },
  [FIELDS.CREDIT_POLICY_EXEMPTION_RATIONALE]: {
    name: FIELDS.CREDIT_POLICY_EXEMPTION_RATIONALE,
    label: 'Credit Policy Exception details',
  },
  [FIELDS.APPLICATION_TYPE]: {
    name: FIELDS.APPLICATION_TYPE,
    label: 'Application type',
  },
  [FIELDS.CURRENT_MORTGAGE_PROVIDER]: { name: FIELDS.CURRENT_MORTGAGE_PROVIDER, label: 'Current mortgage lender' },
  [FIELDS.CREATED_BY]: { name: FIELDS.CREATED_BY, label: 'Created by' },
  [FIELDS.UPDATED_AT]: { name: FIELDS.UPDATED_AT, label: 'Updated at' },
  [FIELDS.APPLICATION_DATE]: { name: FIELDS.APPLICATION_DATE, label: 'Application date' },
  [FIELDS.DEBT_TO_INCOME]: { name: FIELDS.DEBT_TO_INCOME, label: 'Debt to Income' },
  [FIELDS.HAS_ADVERSE_CREDIT]: { name: FIELDS.HAS_ADVERSE_CREDIT, label: 'Adverse credit' },
  [FIELDS.DELPHI_CREDIT_REFERENCE_NUMBER]: {
    name: FIELDS.DELPHI_CREDIT_REFERENCE_NUMBER,
    label: 'Credit Reference Number',
  },
  [FIELDS.DELPHI_DATE_OF_SEARCH]: { name: FIELDS.DELPHI_DATE_OF_SEARCH, label: 'Date of search' },
  [FIELDS.DELPHI_SCORE]: { name: FIELDS.DELPHI_SCORE, label: 'Delphi Score' },
  [FIELDS.DEPOSIT_SOURCE_BUILDERS]: { name: FIELDS.DEPOSIT_SOURCE_BUILDERS, label: 'Builder / Developer incentives' },
  [FIELDS.DEPOSIT_SOURCE_DETAILS]: { name: FIELDS.DEPOSIT_SOURCE_DETAILS, label: `'Other' deposit source details` },
  [FIELDS.DEPOSIT_SOURCE_EQUITY_FROM_SALE]: {
    name: FIELDS.DEPOSIT_SOURCE_EQUITY_FROM_SALE,
    label: 'Equity from sale of current property',
  },
  [FIELDS.DEPOSIT_SOURCE_GIFTS]: { name: FIELDS.DEPOSIT_SOURCE_GIFTS, label: 'Family Gift' },
  [FIELDS.DEPOSIT_SOURCE_OTHER]: { name: FIELDS.DEPOSIT_SOURCE_OTHER, label: 'Other' },
  [FIELDS.DEPOSIT_SOURCE_SAVINGS]: { name: FIELDS.DEPOSIT_SOURCE_SAVINGS, label: 'Savings' },
  [FIELDS.ESTIMATED_PROPERTY_VALUE]: { name: FIELDS.ESTIMATED_PROPERTY_VALUE, label: 'Est. Property Value' },
  [FIELDS.ID]: { name: FIELDS.ID, label: 'id' },
  [FIELDS.IS_BUY_TO_LET]: { name: FIELDS.IS_BUY_TO_LET, label: 'Buy-to-Let' },
  [FIELDS.IS_CREDIT_POLICY_EXEMPTION]: { name: FIELDS.IS_CREDIT_POLICY_EXEMPTION, label: 'Credit Policy Exception' },
  [FIELDS.IS_FIRST_TIME_BUYER]: { name: FIELDS.IS_FIRST_TIME_BUYER, label: 'First Time Buyer' },
  [FIELDS.IS_PRIVATE_SALE]: { name: FIELDS.IS_PRIVATE_SALE, label: 'Private Sale' },
  [FIELDS.LOAN_AMOUNT_PURCHASE]: { name: FIELDS.LOAN_AMOUNT_PURCHASE, label: 'Purpose - Purchase' },
  [FIELDS.LOAN_AMOUNT_REMORTGAGE]: { name: FIELDS.LOAN_AMOUNT_REMORTGAGE, label: 'Purpose - Remortgage' },
  [FIELDS.LOAN_ASSISTING_OTHERS]: { name: FIELDS.LOAN_ASSISTING_OTHERS, label: 'Purpose - Assisting Others' },
  [FIELDS.LOAN_OTHER_PURPOSES]: { name: FIELDS.LOAN_OTHER_PURPOSES, label: 'Purpose - Others' },
  [FIELDS.LOAN_DEBT_CONSOLIDATION]: { name: FIELDS.LOAN_DEBT_CONSOLIDATION, label: 'Purpose - Debt consolidation' },
  [FIELDS.LOAN_DISCRETIONARY_SPEND]: { name: FIELDS.LOAN_DISCRETIONARY_SPEND, label: 'Purpose - Discretionary spend' },
  [FIELDS.LOAN_HOME_IMPROVEMENTS]: { name: FIELDS.LOAN_HOME_IMPROVEMENTS, label: 'Purpose - Home improvements' },
  [FIELDS.MONTHLY_BASIC_SPEND]: { name: FIELDS.MONTHLY_BASIC_SPEND, label: 'Monthly living costs' },
  [FIELDS.NUMBER_OF_APPLICANTS]: { name: FIELDS.NUMBER_OF_APPLICANTS, label: 'No. of applicants' },
  [FIELDS.OWNER]: { name: FIELDS.OWNER, label: 'Case Owner' },
  [FIELDS.PEPPER_PURPOSE_OF_THE_LOAN]: { name: FIELDS.PEPPER_PURPOSE_OF_THE_LOAN, label: 'Servicing loan purpose' },
  [FIELDS.POSTCODE]: { name: FIELDS.POSTCODE, label: 'Property Postcode' },
  [FIELDS.PRODUCT_TIER]: { name: FIELDS.PRODUCT_TIER, label: 'Product group' },
  [FIELDS.PRODUCT_CODE]: { name: FIELDS.PRODUCT_CODE, label: 'Mortgage Product' },
  [FIELDS.PRODUCT_REPAYMENT_TYPE]: { name: FIELDS.PRODUCT_REPAYMENT_TYPE, label: 'Repayment type' },
  [FIELDS.TERM_LENGTH]: { name: FIELDS.TERM_LENGTH, label: 'Term Length' },

  [FIELDS.PRODUCT_FEE]: { name: FIELDS.PRODUCT_FEE, label: 'Product Fee' },
  [FIELDS.PRODUCT_FEE_PAYMENT_METHOD]: { name: FIELDS.PRODUCT_FEE_PAYMENT_METHOD, label: 'Product fee payment method' },
  [FIELDS.PRODUCT_FIXED_INTEREST_RATE]: { name: FIELDS.PRODUCT_FIXED_INTEREST_RATE, label: 'Fixed Interest Rate' },
  [FIELDS.PRODUCT_FIXED_TERM]: { name: FIELDS.PRODUCT_FIXED_TERM, label: 'Fixed Term' },
  [FIELDS.PRODUCT_REVERSION_RATE]: { name: FIELDS.PRODUCT_REVERSION_RATE, label: 'Reversion Rate' },
  [FIELDS.PROPERTY_PURCHASE_PRICE]: { name: FIELDS.PROPERTY_PURCHASE_PRICE, label: 'Property Purchase Price' },
  [FIELDS.PURPOSE_OF_CAPITAL_RAISE]: { name: FIELDS.PURPOSE_OF_CAPITAL_RAISE, label: 'Capital raise purpose' },
  [FIELDS.PURPOSE_OF_THE_LOAN]: { name: FIELDS.PURPOSE_OF_THE_LOAN, label: 'Loan purpose' },
  [FIELDS.RATIONALE]: { name: FIELDS.RATIONALE, label: '' },
  [FIELDS.SORT_CODE]: { name: FIELDS.SORT_CODE, label: 'Sort Code' },
  [FIELDS.SOURCE_OF_DEPOSIT]: { name: FIELDS.SOURCE_OF_DEPOSIT, label: 'Source of deposit' },
  [FIELDS.STAGE]: { name: FIELDS.STAGE, label: 'stage' },
  [FIELDS.STATUS]: { name: FIELDS.STATUS, label: 'Case Status' },
  [FIELDS.IS_ON_HOLD_STATUS]: { name: FIELDS.IS_ON_HOLD_STATUS, label: 'On hold' },
  [FIELDS.IS_APPLICATION_APPROVED_AUTHORITY_LEVELS]: {
    name: FIELDS.IS_APPLICATION_APPROVED_AUTHORITY_LEVELS,
    label: 'Application approved in line with delegated authority levels',
  },
  [FIELDS.IS_CALL_CARRIED_ALL_APPLICANTS]: {
    name: FIELDS.IS_CALL_CARRIED_ALL_APPLICANTS,
    label: 'Pre-offer call carried out for all applicants',
  },
  [FIELDS.IS_PEPPER_UPLOAD_APPROVED]: {
    name: FIELDS.IS_PEPPER_UPLOAD_APPROVED,
    label: 'Servicing Upload Approved',
  },
  [FIELDS.VALUATION_FEE_AMOUNT]: { name: FIELDS.VALUATION_FEE_AMOUNT, label: 'Valuation Fee' },
  [FIELDS.VALUATION_FEE_PAYMENT]: { name: FIELDS.VALUATION_FEE_PAYMENT, label: 'Valuation Fee payment' },
  [FIELDS.RE_INSPECTION_FEE]: { name: FIELDS.RE_INSPECTION_FEE, label: 'Re-inspection fee' },
  [FIELDS.ADVISER_NAME]: { name: FIELDS.ADVISER_NAME, label: 'Name' },
  [FIELDS.ADVISER_FEE]: { name: FIELDS.ADVISER_FEE, label: 'Adviser fee' },
  [FIELDS.ADVISER_PHONE]: { name: FIELDS.ADVISER_PHONE, label: 'Phone' },
  [FIELDS.ADVISER_EMAIL]: { name: FIELDS.ADVISER_EMAIL, label: 'Email' },
  [FIELDS.STANDARD_COMMISSION_TERMS]: {
    name: FIELDS.STANDARD_COMMISSION_TERMS,
    label: 'Standard Commission Term',
  },
  [FIELDS.ENHANCED_COMMISSION_TERMS]: {
    name: FIELDS.ENHANCED_COMMISSION_TERMS,
    label: 'Enhanced Commission Term',
  },
  [FIELDS.ONGOING_COMMISSION_TERMS_UPFRONT_FEE]: {
    name: FIELDS.ONGOING_COMMISSION_TERMS_UPFRONT_FEE,
    label: 'Ongoing Commission Term: up-front fee',
  },
  [FIELDS.ONGOING_COMMISSION_TERMS_ONGOING_FEE]: {
    name: FIELDS.ONGOING_COMMISSION_TERMS_ONGOING_FEE,
    label: 'Ongoing Commission Term: ongoing fee',
  },
  [FIELDS.CLUB_NAME]: { name: FIELDS.CLUB_NAME, label: 'Club Name' },
  [FIELDS.SUBMISSION_ROUTE]: { name: FIELDS.SUBMISSION_ROUTE, label: 'Submission route' },
  [FIELDS.COMMISSION_PAID_TO]: { name: FIELDS.COMMISSION_PAID_TO, label: 'Commission paid to' },
  [FIELDS.NETWORK_NAME]: { name: FIELDS.NETWORK_NAME, label: 'Network Name' },
  [FIELDS.FIRM_NAME]: { name: FIELDS.FIRM_NAME, label: 'Firm Name' },
  [FIELDS.FIRM_FCA_NUMBER]: { name: FIELDS.FIRM_FCA_NUMBER, label: 'Firm FCA Number' },
  [FIELDS.FIRM_ADDRESS]: { name: FIELDS.FIRM_ADDRESS, label: 'Firm Address' },
  [FIELDS.NETWORK_FCA_NUMBER]: { name: FIELDS.NETWORK_FCA_NUMBER, label: 'Network FCA Number' },
  [FIELDS.ADVISER_FEE_LAST_PAYMENT_MOMENT]: {
    name: FIELDS.ADVISER_FEE_LAST_PAYMENT_MOMENT,
    label: 'Last payment point',
  },
  [FIELDS.PACKAGER_FEE]: {
    name: FIELDS.PACKAGER_FEE,
    label: 'Packager fee',
  },
  [FIELDS.PACKAGER_FEE_LAST_PAYMENT_MOMENT]: {
    name: FIELDS.PACKAGER_FEE_LAST_PAYMENT_MOMENT,
    label: 'Last payment point',
  },
  [FIELDS.UPFRONT_COMMISSION_AMOUNT]: { name: FIELDS.UPFRONT_COMMISSION_AMOUNT, label: 'Up-front Commission Amount' },
  [FIELDS.ONGOING_COMMISSION_AMOUNT]: { name: FIELDS.ONGOING_COMMISSION_AMOUNT, label: 'Ongoing Commission Amount' },
  [FIELDS.EXPENDITURES_PREFIX]: (prefix: string = '') => ({
    [FIELDS.EXPENDITURE_ID]: {
      name: FIELDS.EXPENDITURE_ID,
      label: 'EXPENDITURE_ID',
      prefix: `${FIELDS.EXPENDITURES_PREFIX}.${prefix}.`,
    },
    [FIELDS.EXPENDITURE_TYPE]: {
      name: FIELDS.EXPENDITURE_TYPE,
      label: 'EXPENDITURE_TYPE',
      prefix: `${FIELDS.EXPENDITURES_PREFIX}.${prefix}.`,
    },
    [FIELDS.EXPENDITURE_CREDIT_LIMIT]: {
      name: FIELDS.EXPENDITURE_CREDIT_LIMIT,
      label: 'EXPENDITURE_CREDIT_LIMIT',
      prefix: `${FIELDS.EXPENDITURES_PREFIX}.${prefix}.`,
    },
    [FIELDS.EXPENDITURE_BALANCE]: {
      name: FIELDS.EXPENDITURE_BALANCE,
      label: 'EXPENDITURE_BALANCE',
      prefix: `${FIELDS.EXPENDITURES_PREFIX}.${prefix}.`,
    },
    [FIELDS.EXPENDITURE_DESCRIPTION]: {
      name: FIELDS.EXPENDITURE_DESCRIPTION,
      label: 'EXPENDITURE_DESCRIPTION',
      prefix: `${FIELDS.EXPENDITURES_PREFIX}.${prefix}.`,
    },
    [FIELDS.EXPENDITURE_AMOUNT]: {
      name: FIELDS.EXPENDITURE_AMOUNT,
      label: 'EXPENDITURE_AMOUNT',
      prefix: `${FIELDS.EXPENDITURES_PREFIX}.${prefix}.`,
    },
    [FIELDS.EXPENDITURE_FREQUENCY]: {
      name: FIELDS.EXPENDITURE_FREQUENCY,
      label: 'EXPENDITURE_FREQUENCY',
      prefix: `${FIELDS.EXPENDITURES_PREFIX}.${prefix}.`,
    },
    [FIELDS.EXPENDITURE_END_DATE]: {
      name: FIELDS.EXPENDITURE_END_DATE,
      label: 'EXPENDITURE_END_DATE',
      prefix: `${FIELDS.EXPENDITURES_PREFIX}.${prefix}.`,
    },
    [FIELDS.EXPENDITURE_TOTAL_NUMBER_OF_PROPERTIES]: {
      name: FIELDS.EXPENDITURE_TOTAL_NUMBER_OF_PROPERTIES,
      label: 'EXPENDITURE_TOTAL_NUMBER_OF_PROPERTIES',
      prefix: `${FIELDS.EXPENDITURES_PREFIX}.${prefix}.`,
    },
    [FIELDS.EXPENDITURE_WILL_BE_CLEARED_BEFORE_LOAN]: {
      name: FIELDS.EXPENDITURE_WILL_BE_CLEARED_BEFORE_LOAN,
      label: 'EXPENDITURE_WILL_BE_CLEARED_BEFORE_LOAN',
      prefix: `${FIELDS.EXPENDITURES_PREFIX}.${prefix}.`,
    },
    [FIELDS.EXPENDITURE_WILL_BE_CLEARED_BY_LOAN]: {
      name: FIELDS.EXPENDITURE_WILL_BE_CLEARED_BY_LOAN,
      label: 'EXPENDITURE_WILL_BE_CLEARED_BY_LOAN',
      prefix: `${FIELDS.EXPENDITURES_PREFIX}.${prefix}.`,
    },
  }),
  [FIELDS.COMMITMENT_TO_BE_CLEARED]: () => ({
    [FIELDS.MONTHLY_AMOUNT]: {
      name: FIELDS.MONTHLY_AMOUNT,
      label: 'Monthly amount',
      prefix: `${FIELDS.COMMITMENT_TO_BE_CLEARED}.`,
    },
    [FIELDS.BALANCE]: { name: FIELDS.BALANCE, label: 'Balance', prefix: `${FIELDS.COMMITMENT_TO_BE_CLEARED}.` },
  }),
  [FIELDS.COMMITMENT_REMAINING]: () => ({
    [FIELDS.MONTHLY_AMOUNT]: {
      name: FIELDS.MONTHLY_AMOUNT,
      label: 'Monthly amount',
      prefix: `${FIELDS.COMMITMENT_REMAINING}.`,
    },
    [FIELDS.BALANCE]: { name: FIELDS.BALANCE, label: 'Balance', prefix: `${FIELDS.COMMITMENT_REMAINING}.` },
  }),
  [FIELDS.HAS_MARKETING_EMAIL]: { name: FIELDS.HAS_MARKETING_EMAIL, label: 'Email' },
  [FIELDS.HAS_MARKETING_PHONE]: { name: FIELDS.HAS_MARKETING_PHONE, label: 'Telephone' },
  [FIELDS.HAS_MARKETING_POST]: { name: FIELDS.HAS_MARKETING_POST, label: 'Post' },
  [FIELDS.HAS_MARKETING_SMS]: { name: FIELDS.HAS_MARKETING_SMS, label: 'SMS' },

  [FIELDS.APPLICANT_TITLE]: { name: FIELDS.APPLICANT_TITLE, label: 'Title' },
  [FIELDS.APPLICANT_NAME]: { name: FIELDS.APPLICANT_NAME, label: 'First Name' },
  [FIELDS.APPLICANT_SURNAME]: { name: FIELDS.APPLICANT_SURNAME, label: 'Last Name' },
  [FIELDS.APPLICANT_MIDDLE_NAME]: { name: FIELDS.APPLICANT_MIDDLE_NAME, label: 'Middle Name' },
  [FIELDS.APPLICANT_PREVIOUS_NAME]: { name: FIELDS.APPLICANT_PREVIOUS_NAME, label: 'Previous Name' },
  [FIELDS.APPLICANT_PROOF_OF_ID]: { name: FIELDS.APPLICANT_PROOF_OF_ID, label: 'Proof of ID' },
  [FIELDS.APPLICANT_DATE_OF_BIRTH]: { name: FIELDS.APPLICANT_DATE_OF_BIRTH, label: 'Date of Birth' },
  [FIELDS.APPLICANT_AGE]: { name: FIELDS.APPLICANT_AGE, label: 'Age' },
  [FIELDS.APPLICANT_PLANNED_RETIREMENT_AGE]: {
    name: FIELDS.APPLICANT_PLANNED_RETIREMENT_AGE,
    label: 'APPLICANT_PLANNED_RETIREMENT_AGE',
  },
  [FIELDS.APPLICANT_GENDER]: { name: FIELDS.APPLICANT_GENDER, label: 'Gender' },
  [FIELDS.APPLICANT_MARITAL_STATUS]: { name: FIELDS.APPLICANT_MARITAL_STATUS, label: 'Marital Status' },
  [FIELDS.APPLICANT_CURRENT_ADDRESS]: { name: FIELDS.APPLICANT_CURRENT_ADDRESS, label: 'APPLICANT_CURRENT_ADDRESS' },
  [FIELDS.APPLICANT_NATIONALITY]: { name: FIELDS.APPLICANT_NATIONALITY, label: 'Nationality' },
  [FIELDS.APPLICANT_IS_UK_RESIDENT]: { name: FIELDS.APPLICANT_IS_UK_RESIDENT, label: 'UK Resident' },
  [FIELDS.APPLICANT_HAS_INDEFINITE_LEAVE_TO_REMAIN]: {
    name: FIELDS.APPLICANT_HAS_INDEFINITE_LEAVE_TO_REMAIN,
    label: 'Indefinite leave to remain',
  },
  [FIELDS.APPLICANT_PHONE_HOME]: { name: FIELDS.APPLICANT_PHONE_HOME, label: 'Home number' },
  [FIELDS.APPLICANT_IS_PHONE_HOME_PEPPER]: {
    name: FIELDS.APPLICANT_IS_PHONE_HOME_PEPPER,
    label: 'Upload contact',
  },
  [FIELDS.APPLICANT_PHONE_MOBILE]: { name: FIELDS.APPLICANT_PHONE_MOBILE, label: 'Mobile number' },
  [FIELDS.APPLICANT_IS_PHONE_MOBILE_PEPPER]: {
    name: FIELDS.APPLICANT_IS_PHONE_MOBILE_PEPPER,
    label: 'Upload contact',
  },
  [FIELDS.APPLICANT_PHONE_WORK]: { name: FIELDS.APPLICANT_PHONE_WORK, label: 'Work number' },
  [FIELDS.APPLICANT_IS_PHONE_WORK_PEPPER]: {
    name: FIELDS.APPLICANT_IS_PHONE_WORK_PEPPER,
    label: 'Upload contact',
  },
  [FIELDS.APPLICANT_EMAIL]: { name: FIELDS.APPLICANT_EMAIL, label: 'Email Address' },
  [FIELDS.APPLICANT_IS_EMAIL_PEPPER]: { name: FIELDS.APPLICANT_IS_EMAIL_PEPPER, label: 'Upload contact' },
  [FIELDS.APPLICANT_ADDITIONAL_EMAIL]: { name: FIELDS.APPLICANT_ADDITIONAL_EMAIL, label: 'Additional Email' },
  [FIELDS.APPLICANT_ADDITIONAL_EMAIL_PEPPER]: {
    name: FIELDS.APPLICANT_ADDITIONAL_EMAIL_PEPPER,
    label: 'Upload contact',
  },
  [FIELDS.APPLICANT_IS_CRIMINAL]: { name: FIELDS.APPLICANT_IS_CRIMINAL, label: 'Criminal convictions' },
  [FIELDS.APPLICANT_CRIMINAL_CONVICTIONS_DETAIL]: {
    name: FIELDS.APPLICANT_CRIMINAL_CONVICTIONS_DETAIL,
    label: 'Criminal convictions detail',
  },
  [FIELDS.APPLICANT_HAS_ADVERSE_CREDIT]: {
    name: FIELDS.APPLICANT_HAS_ADVERSE_CREDIT,
    label: 'Adverse credit',
  },
  [FIELDS.APPLICANT_ADVERSE_CREDIT_DETAILS]: {
    name: FIELDS.APPLICANT_ADVERSE_CREDIT_DETAILS,
    label: 'Adverse credit detail',
  },
  [FIELDS.APPLICANT_BANKRUPTCY_AMOUNT]: {
    name: FIELDS.APPLICANT_BANKRUPTCY_AMOUNT,
    label: 'Bankruptcy amount',
  },
  [FIELDS.APPLICANT_BANKRUPTCY_LATEST_DATE]: {
    name: FIELDS.APPLICANT_BANKRUPTCY_LATEST_DATE,
    label: 'Bankruptcy latest date',
  },
  [FIELDS.APPLICANT_CCJ_AMOUNT]: { name: FIELDS.APPLICANT_CCJ_AMOUNT, label: 'CCJ amount' },
  [FIELDS.APPLICANT_CCJ_LATEST_DATE]: { name: FIELDS.APPLICANT_CCJ_LATEST_DATE, label: 'CCJ latest date' },
  [FIELDS.APPLICANT_DEFAULT_AMOUNT]: { name: FIELDS.APPLICANT_DEFAULT_AMOUNT, label: 'Default amount' },
  [FIELDS.APPLICANT_DEFAULT_LAST_DATE]: {
    name: FIELDS.APPLICANT_DEFAULT_LAST_DATE,
    label: 'Default latest date',
  },
  [FIELDS.APPLICANT_MORTGAGE_ARREARS_AMOUNT]: {
    name: FIELDS.APPLICANT_MORTGAGE_ARREARS_AMOUNT,
    label: 'Mortgage arrears amount',
  },
  [FIELDS.APPLICANT_MORTGAGE_ARREARS_LATEST_DATE]: {
    name: FIELDS.APPLICANT_MORTGAGE_ARREARS_LATEST_DATE,
    label: 'Mortgage arrears latest date',
  },
  [FIELDS.APPLICANT_POWER_OF_ATTORNEY]: {
    [FIELDS.APPLICANT_POWER_OF_ATTORNEY_NAME]: {
      name: FIELDS.APPLICANT_POWER_OF_ATTORNEY_NAME,
      prefix: `${FIELDS.APPLICANT_POWER_OF_ATTORNEY}.`,
      label: 'POA name',
    },
    [FIELDS.APPLICANT_POWER_OF_ATTORNEY_HAS_CUSTOMISED_SERVICES]: {
      name: FIELDS.APPLICANT_POWER_OF_ATTORNEY_HAS_CUSTOMISED_SERVICES,
      prefix: `${FIELDS.APPLICANT_POWER_OF_ATTORNEY}.`,
      label: 'Customised Services',
    },
    [FIELDS.APPLICANT_POWER_OF_ATTORNEY_CUSTOMISED_SERVICES_REQUEST]: {
      name: FIELDS.APPLICANT_POWER_OF_ATTORNEY_CUSTOMISED_SERVICES_REQUEST,
      prefix: `${FIELDS.APPLICANT_POWER_OF_ATTORNEY}.`,
      label: 'Customised Services Request',
    },
    [FIELDS.APPLICANT_POWER_OF_ATTORNEY_PHONE_NUMBER]: {
      name: FIELDS.APPLICANT_POWER_OF_ATTORNEY_PHONE_NUMBER,
      label: 'Contact number',
      prefix: `${FIELDS.APPLICANT_POWER_OF_ATTORNEY}.`,
    },
    [FIELDS.APPLICANT_POWER_OF_ATTORNEY_EMAIL]: {
      name: FIELDS.APPLICANT_POWER_OF_ATTORNEY_EMAIL,
      label: 'Email address',
      prefix: `${FIELDS.APPLICANT_POWER_OF_ATTORNEY}.`,
    },
    [FIELDS.APPLICANT_POWER_OF_ATTORNEY_POSTCODE]: {
      name: FIELDS.APPLICANT_POWER_OF_ATTORNEY_POSTCODE,
      label: 'Postcode',
      prefix: `${FIELDS.APPLICANT_POWER_OF_ATTORNEY}.`,
    },
    [FIELDS.APPLICANT_POWER_OF_ATTORNEY_FLAT_NUMBER]: {
      name: FIELDS.APPLICANT_POWER_OF_ATTORNEY_FLAT_NUMBER,
      label: 'Flat Number',
      prefix: `${FIELDS.APPLICANT_POWER_OF_ATTORNEY}.`,
    },
    [FIELDS.APPLICANT_POWER_OF_ATTORNEY_BUILDING_NAME]: {
      name: FIELDS.APPLICANT_POWER_OF_ATTORNEY_BUILDING_NAME,
      label: 'Building Name',
      prefix: `${FIELDS.APPLICANT_POWER_OF_ATTORNEY}.`,
    },
    [FIELDS.APPLICANT_POWER_OF_ATTORNEY_BUILDING_NUMBER]: {
      name: FIELDS.APPLICANT_POWER_OF_ATTORNEY_BUILDING_NUMBER,
      label: 'Building Number',
      prefix: `${FIELDS.APPLICANT_POWER_OF_ATTORNEY}.`,
    },
    [FIELDS.APPLICANT_POWER_OF_ATTORNEY_STREET]: {
      name: FIELDS.APPLICANT_POWER_OF_ATTORNEY_STREET,
      label: 'Street',
      prefix: `${FIELDS.APPLICANT_POWER_OF_ATTORNEY}.`,
    },
    [FIELDS.APPLICANT_POWER_OF_ATTORNEY_CITY]: {
      name: FIELDS.APPLICANT_POWER_OF_ATTORNEY_CITY,
      label: 'City',
      prefix: `${FIELDS.APPLICANT_POWER_OF_ATTORNEY}.`,
    },
  },
  [FIELDS.LUMP_SUM_DRAWDOWN]: {
    name: FIELDS.LUMP_SUM_DRAWDOWN,
    label: 'Lump sum drawdown',
  },
  [FIELDS.REPAYMENT_LUMP_SUM]: {
    name: FIELDS.REPAYMENT_LUMP_SUM,
    label: 'Repayment lump sum',
  },

  [FIELDS.APPLICANT_CURRENT_ADDRESS]: {
    [FIELDS.APPLICANT_ADDRESS_FLAT_NUMBER]: {
      name: FIELDS.APPLICANT_ADDRESS_FLAT_NUMBER,
      prefix: `${FIELDS.APPLICANT_CURRENT_ADDRESS}.`,
      label: 'Flat Number',
    },
    [FIELDS.APPLICANT_ADDRESS_BUILDING_NAME]: {
      name: FIELDS.APPLICANT_ADDRESS_BUILDING_NAME,
      prefix: `${FIELDS.APPLICANT_CURRENT_ADDRESS}.`,
      label: 'Building Name',
    },
    [FIELDS.APPLICANT_ADDRESS_BUILDING_NUMBER]: {
      name: FIELDS.APPLICANT_ADDRESS_BUILDING_NUMBER,
      prefix: `${FIELDS.APPLICANT_CURRENT_ADDRESS}.`,
      label: 'Building Number',
    },
    [FIELDS.APPLICANT_ADDRESS_STREET]: {
      name: FIELDS.APPLICANT_ADDRESS_STREET,
      prefix: `${FIELDS.APPLICANT_CURRENT_ADDRESS}.`,
      label: 'Street',
    },
    [FIELDS.APPLICANT_ADDRESS_CITY]: {
      name: FIELDS.APPLICANT_ADDRESS_CITY,
      prefix: `${FIELDS.APPLICANT_CURRENT_ADDRESS}.`,
      label: 'City',
    },
    [FIELDS.APPLICANT_ADDRESS_POSTCODE]: {
      name: FIELDS.APPLICANT_ADDRESS_POSTCODE,
      prefix: `${FIELDS.APPLICANT_CURRENT_ADDRESS}.`,
      label: 'Postcode',
    },
    [FIELDS.APPLICANT_ADDRESS_MOVED_IN_DATE]: {
      name: FIELDS.APPLICANT_ADDRESS_MOVED_IN_DATE,
      prefix: `${FIELDS.APPLICANT_CURRENT_ADDRESS}.`,
      label: 'Date moved to current address',
    },
    [FIELDS.APPLICANT_ADDRESS_PROOF_OF_ADDRESS]: {
      name: FIELDS.APPLICANT_ADDRESS_PROOF_OF_ADDRESS,
      prefix: `${FIELDS.APPLICANT_CURRENT_ADDRESS}.`,
      label: 'Proof of address',
    },
  },
  [FIELDS.APPLICANT_PREVIOUS_ADDRESSES]: (prefix: number) => ({
    [FIELDS.APPLICANT_ADDRESS_FLAT_NUMBER]: {
      name: FIELDS.APPLICANT_ADDRESS_FLAT_NUMBER,
      prefix: `${FIELDS.APPLICANT_PREVIOUS_ADDRESSES}.${prefix}.`,
      label: 'Flat Number',
    },
    [FIELDS.APPLICANT_ADDRESS_BUILDING_NAME]: {
      name: FIELDS.APPLICANT_ADDRESS_BUILDING_NAME,
      prefix: `${FIELDS.APPLICANT_PREVIOUS_ADDRESSES}.${prefix}.`,
      label: 'Building Name',
    },
    [FIELDS.APPLICANT_ADDRESS_BUILDING_NUMBER]: {
      name: FIELDS.APPLICANT_ADDRESS_BUILDING_NUMBER,
      prefix: `${FIELDS.APPLICANT_PREVIOUS_ADDRESSES}.${prefix}.`,
      label: 'Building Number',
    },
    [FIELDS.APPLICANT_ADDRESS_STREET]: {
      name: FIELDS.APPLICANT_ADDRESS_STREET,
      prefix: `${FIELDS.APPLICANT_PREVIOUS_ADDRESSES}.${prefix}.`,
      label: 'Street',
    },
    [FIELDS.APPLICANT_ADDRESS_CITY]: {
      name: FIELDS.APPLICANT_ADDRESS_CITY,
      prefix: `${FIELDS.APPLICANT_PREVIOUS_ADDRESSES}.${prefix}.`,
      label: 'City',
    },
    [FIELDS.APPLICANT_ADDRESS_POSTCODE]: {
      name: FIELDS.APPLICANT_ADDRESS_POSTCODE,
      prefix: `${FIELDS.APPLICANT_PREVIOUS_ADDRESSES}.${prefix}.`,
      label: 'Postcode',
    },
    [FIELDS.APPLICANT_ADDRESS_MOVED_IN_DATE]: {
      name: FIELDS.APPLICANT_ADDRESS_MOVED_IN_DATE,
      prefix: `${FIELDS.APPLICANT_PREVIOUS_ADDRESSES}.${prefix}.`,
      label: 'Date moved to previous address',
    },
  }),
  [FIELDS.ASSETS_PREFIX]: (prefix: number) => ({
    [FIELDS.ASSETS_TYPE]: {
      name: FIELDS.ASSETS_TYPE,
      prefix: `${FIELDS.ASSETS_PREFIX}.${prefix}.`,
      label: 'Type',
    },
    [FIELDS.ASSETS_VALUE]: {
      name: FIELDS.ASSETS_VALUE,
      prefix: `${FIELDS.ASSETS_PREFIX}.${prefix}.`,
      label: 'Value',
    },
    [FIELDS.ASSETS_DESCRIPTION]: {
      name: FIELDS.ASSETS_DESCRIPTION,
      prefix: `${FIELDS.ASSETS_PREFIX}.${prefix}.`,
      label: 'Description',
    },
    [FIELDS.ASSETS_WILL_BE_USED_TO_PAY_LOAN]: {
      name: FIELDS.ASSETS_WILL_BE_USED_TO_PAY_LOAN,
      prefix: `${FIELDS.ASSETS_PREFIX}.${prefix}.`,
      label: 'Asset to be sold to pay loan',
    },
    [FIELDS.ASSETS_OUTSTANDING_MORTGAGE_BALANCE]: {
      name: FIELDS.ASSETS_OUTSTANDING_MORTGAGE_BALANCE,
      prefix: `${FIELDS.ASSETS_PREFIX}.${prefix}.`,
      label: 'Outstanding mortgage balance',
    },
    [FIELDS.ASSETS_PROPERTY_CITY]: {
      name: FIELDS.ASSETS_PROPERTY_CITY,
      prefix: `${FIELDS.ASSETS_PREFIX}.${prefix}.`,
      label: 'City',
    },
    [FIELDS.ASSETS_PROPERTY_POSTCODE]: {
      name: FIELDS.ASSETS_PROPERTY_POSTCODE,
      prefix: `${FIELDS.ASSETS_PREFIX}.${prefix}.`,
      label: 'Postcode',
    },
    [FIELDS.ASSETS_PROPERTY_FLAT_NUMBER]: {
      name: FIELDS.ASSETS_PROPERTY_FLAT_NUMBER,
      prefix: `${FIELDS.ASSETS_PREFIX}.${prefix}.`,
      label: 'Flat Number',
    },
    [FIELDS.ASSETS_PROPERTY_BUILDING_NAME]: {
      name: FIELDS.ASSETS_PROPERTY_BUILDING_NAME,
      prefix: `${FIELDS.ASSETS_PREFIX}.${prefix}.`,
      label: 'Building Name',
    },
    [FIELDS.ASSETS_PROPERTY_BUILDING_NUMBER]: {
      name: FIELDS.ASSETS_PROPERTY_BUILDING_NUMBER,
      prefix: `${FIELDS.ASSETS_PREFIX}.${prefix}.`,
      label: 'Building Number',
    },
    [FIELDS.PROPERTY_STREET]: {
      name: FIELDS.PROPERTY_STREET,
      prefix: `${FIELDS.ASSETS_PREFIX}.${prefix}.`,
      label: 'Street',
    },
  }),

  [FIELDS.CURRENT_STATE_PENSION]: {
    name: FIELDS.CURRENT_STATE_PENSION,
    label: 'State Pension ',
  },
  [FIELDS.CURRENT_DB_NAME_OF_SCHEME]: {
    name: FIELDS.CURRENT_DB_NAME_OF_SCHEME,
    label: 'Name of scheme',
  },
  [FIELDS.CURRENT_DB_ANNUAL_INCOME]: {
    name: FIELDS.CURRENT_DB_ANNUAL_INCOME,
    label: 'Annual income',
  },
  [FIELDS.CURRENT_DB_PERCENT_PASSED_ON_DEATH]: {
    name: FIELDS.CURRENT_DB_PERCENT_PASSED_ON_DEATH,
    label: '% passed on death',
  },
  [FIELDS.CURRENT_DC_NAME_OF_SCHEME]: {
    name: FIELDS.CURRENT_DC_NAME_OF_SCHEME,
    label: 'Name of scheme',
  },
  [FIELDS.CURRENT_DC_CURRENT_VALUE]: {
    name: FIELDS.CURRENT_DC_CURRENT_VALUE,
    label: 'Current value',
  },
  [FIELDS.CURRENT_DC_PERCENT_PASSED_ON_DEATH]: {
    name: FIELDS.CURRENT_DC_PERCENT_PASSED_ON_DEATH,
    label: '% passed on death',
  },
  [FIELDS.CURRENT_DC_ANNUAL_INCOME_DRAWN]: {
    name: FIELDS.CURRENT_DC_ANNUAL_INCOME_DRAWN,
    label: 'Annual income drawn',
  },
  [FIELDS.CURRENT_ANNUITY_NAME_OF_ANNUITY_PROVIDER]: {
    name: FIELDS.CURRENT_ANNUITY_NAME_OF_ANNUITY_PROVIDER,
    label: 'Name of annuity provider',
  },
  [FIELDS.CURRENT_ANNUITY_GROSS_ANNUAL_INCOME]: {
    name: FIELDS.CURRENT_ANNUITY_GROSS_ANNUAL_INCOME,
    label: 'Gross annual income',
  },
  [FIELDS.CURRENT_ANNUITY_PERCENT_PASSED_ON_DEATH]: {
    name: FIELDS.CURRENT_ANNUITY_PERCENT_PASSED_ON_DEATH,
    label: '% passed on death',
  },

  [FIELDS.FUTURE_STATE_PENSION]: {
    name: FIELDS.FUTURE_STATE_PENSION,
    label: 'State Pension',
  },
  [FIELDS.FUTURE_PENSION_DEFINED_BENEFITS_PREFIX]: (prefix: number) => ({
    [FIELDS.NAME_OF_SCHEME]: {
      name: FIELDS.NAME_OF_SCHEME,
      prefix: `${FIELDS.FUTURE_PENSION_DEFINED_BENEFITS_PREFIX}.${prefix}.`,
      label: 'Name of scheme',
    },
    [FIELDS.ANNUAL_INCOME]: {
      name: FIELDS.ANNUAL_INCOME,
      prefix: `${FIELDS.FUTURE_PENSION_DEFINED_BENEFITS_PREFIX}.${prefix}.`,
      label: 'Annual income',
    },
    [FIELDS.START_DATE]: {
      name: FIELDS.START_DATE,
      prefix: `${FIELDS.FUTURE_PENSION_DEFINED_BENEFITS_PREFIX}.${prefix}.`,
      label: 'Start date',
    },
    [FIELDS.PERCENTAGE_VALUE_OF_PASSED_ON_DEATH]: {
      name: FIELDS.PERCENTAGE_VALUE_OF_PASSED_ON_DEATH,
      prefix: `${FIELDS.FUTURE_PENSION_DEFINED_BENEFITS_PREFIX}.${prefix}.`,
      label: '% passed on death',
    },
    [FIELDS.FUTURE_PENSION_REPAYMENT_LUMP_SUM]: {
      name: FIELDS.FUTURE_PENSION_REPAYMENT_LUMP_SUM,
      prefix: `${FIELDS.FUTURE_PENSION_DEFINED_BENEFITS_PREFIX}.${prefix}.`,
      label: 'Repayment lump sum',
    },
  }),
  [FIELDS.FUTURE_PENSION_DEFINED_CONTRIBUTIONS_PREFIX]: (prefix: number) => ({
    [FIELDS.NAME_OF_SCHEME]: {
      name: FIELDS.NAME_OF_SCHEME,
      prefix: `${FIELDS.FUTURE_PENSION_DEFINED_CONTRIBUTIONS_PREFIX}.${prefix}.`,
      label: 'Name of scheme',
    },
    [FIELDS.CURRENT_VALUE]: {
      name: FIELDS.CURRENT_VALUE,
      prefix: `${FIELDS.FUTURE_PENSION_DEFINED_CONTRIBUTIONS_PREFIX}.${prefix}.`,
      label: 'Current value',
    },
    [FIELDS.START_DATE]: {
      name: FIELDS.START_DATE,
      prefix: `${FIELDS.FUTURE_PENSION_DEFINED_CONTRIBUTIONS_PREFIX}.${prefix}.`,
      label: 'Start date',
    },
    [FIELDS.ONGOING_MONTHLY_CONTRIBUTIONS]: {
      name: FIELDS.ONGOING_MONTHLY_CONTRIBUTIONS,
      prefix: `${FIELDS.FUTURE_PENSION_DEFINED_CONTRIBUTIONS_PREFIX}.${prefix}.`,
      label: 'Ongoing monthly contributions',
    },
    [FIELDS.PERCENTAGE_VALUE_OF_PASSED_ON_DEATH]: {
      name: FIELDS.PERCENTAGE_VALUE_OF_PASSED_ON_DEATH,
      prefix: `${FIELDS.FUTURE_PENSION_DEFINED_CONTRIBUTIONS_PREFIX}.${prefix}.`,
      label: '% passed on death',
    },
    [FIELDS.FUTURE_ANNUAL_INCOME_DRAWN]: {
      name: FIELDS.FUTURE_ANNUAL_INCOME_DRAWN,
      prefix: `${FIELDS.FUTURE_PENSION_DEFINED_CONTRIBUTIONS_PREFIX}.${prefix}.`,
      label: 'Annual income drawn',
    },
    [FIELDS.USE_OF_FUND]: {
      name: FIELDS.USE_OF_FUND,
      prefix: `${FIELDS.FUTURE_PENSION_DEFINED_CONTRIBUTIONS_PREFIX}.${prefix}.`,
      label: 'Use of funds',
    },
  }),
  [FIELDS.FUTURE_ANNUITY_PREFIX]: (prefix: number) => ({
    [FIELDS.FUTURE_ANNUITY_NAME_OF_ANNUITY_PROVIDER]: {
      name: FIELDS.FUTURE_ANNUITY_NAME_OF_ANNUITY_PROVIDER,
      prefix: `${FIELDS.FUTURE_ANNUITY_PREFIX}.${prefix}.`,
      label: 'Name of annuity provider',
    },
    [FIELDS.FUTURE_ANNUITY_GROSS_ANNUAL_INCOME]: {
      name: FIELDS.FUTURE_ANNUITY_GROSS_ANNUAL_INCOME,
      prefix: `${FIELDS.FUTURE_ANNUITY_PREFIX}.${prefix}.`,
      label: 'Gross annual income',
    },
    [FIELDS.FUTURE_ANNUITY_PERCENT_PASSED_ON_DEATH]: {
      name: FIELDS.FUTURE_ANNUITY_PERCENT_PASSED_ON_DEATH,
      prefix: `${FIELDS.FUTURE_ANNUITY_PREFIX}.${prefix}.`,
      label: '% passed on death',
    },
  }),

  [FIELDS.APPLICANT_EMPLOYMENT_STATUS]: {
    name: FIELDS.APPLICANT_EMPLOYMENT_STATUS,
    label: 'Employment Status',
  },
  [FIELDS.APPLICANT_EMPLOYED_JOB_TITLE]: {
    name: FIELDS.APPLICANT_EMPLOYED_JOB_TITLE,
    label: 'Job title',
  },
  [FIELDS.APPLICANT_EMPLOYED_COMPANY_NAME]: {
    name: FIELDS.APPLICANT_EMPLOYED_COMPANY_NAME,
    label: 'Company name',
  },
  [FIELDS.APPLICANT_EMPLOYED_COMPANY_ADDRESS]: {
    name: FIELDS.APPLICANT_EMPLOYED_COMPANY_ADDRESS,
    label: 'Company address',
  },
  [FIELDS.APPLICANT_EMPLOYED_NATURE]: { name: FIELDS.APPLICANT_EMPLOYED_NATURE, label: 'Nature of employment' },
  [FIELDS.APPLICANT_EMPLOYED_START_DATE]: {
    name: FIELDS.APPLICANT_EMPLOYED_START_DATE,
    label: 'Employment start date',
  },
  [FIELDS.APPLICANT_EMPLOYED_ANTICIPATED_AGE]: {
    name: FIELDS.APPLICANT_EMPLOYED_ANTICIPATED_AGE,
    label: 'Anticipated retirement age',
  },
  [FIELDS.APPLICANT_SELF_EMPLOYED_JOB_TITLE]: {
    name: FIELDS.APPLICANT_SELF_EMPLOYED_JOB_TITLE,
    label: 'Job title',
  },
  [FIELDS.APPLICANT_SELF_EMPLOYED_COMPANY_NAME]: {
    name: FIELDS.APPLICANT_SELF_EMPLOYED_COMPANY_NAME,
    label: 'Company name',
  },
  [FIELDS.APPLICANT_SELF_EMPLOYED_COMPANY_ADDRESS]: {
    name: FIELDS.APPLICANT_SELF_EMPLOYED_COMPANY_ADDRESS,
    label: 'Company address',
  },
  [FIELDS.APPLICANT_SELF_EMPLOYED_NATURE]: {
    name: FIELDS.APPLICANT_SELF_EMPLOYED_NATURE,
    label: 'Nature of employment',
  },
  [FIELDS.APPLICANT_SELF_EMPLOYED_START_DATE]: {
    name: FIELDS.APPLICANT_SELF_EMPLOYED_START_DATE,
    label: 'Business trading date',
  },
  [FIELDS.APPLICANT_BUSINESS_TYPE]: { name: FIELDS.APPLICANT_BUSINESS_TYPE, label: 'Business type' },
  [FIELDS.APPLICANT_SELF_EMPLOYED_ANTICIPATED_AGE]: {
    name: FIELDS.APPLICANT_SELF_EMPLOYED_ANTICIPATED_AGE,
    label: 'Anticipated retirement age',
  },
  [FIELDS.PROPERTY_FLAT_NUMBER]: { name: FIELDS.PROPERTY_FLAT_NUMBER, label: 'Flat Number' },
  [FIELDS.PROPERTY_BUILDING_NAME]: { name: FIELDS.PROPERTY_BUILDING_NAME, label: 'Building Name' },
  [FIELDS.PROPERTY_BUILDING_NUMBER]: { name: FIELDS.PROPERTY_BUILDING_NUMBER, label: 'Building Number' },
  [FIELDS.PROPERTY_STREET]: { name: FIELDS.PROPERTY_STREET, label: 'Street' },
  [FIELDS.PROPERTY_CITY]: { name: FIELDS.PROPERTY_CITY, label: 'City' },
  [FIELDS.PROPERTY_POSTCODE]: { name: FIELDS.PROPERTY_POSTCODE, label: 'Postcode' },
  [FIELDS.PROPERTY_HAS_OCCUPANTS_OVER17]: {
    name: FIELDS.PROPERTY_HAS_OCCUPANTS_OVER17,
    label: 'PROPERTY_HAS_OCCUPANTS_OVER17',
  },
  [FIELDS.PROPERTY_IS_PRIMARY_HOME]: { name: FIELDS.PROPERTY_IS_PRIMARY_HOME, label: 'Primary Residence' },
  [FIELDS.PROPERTY_TYPE]: { name: FIELDS.PROPERTY_TYPE, label: 'Property Type' },
  [FIELDS.PROPERTY_FLOOR_NUMBER]: { name: FIELDS.PROPERTY_FLOOR_NUMBER, label: 'Floor number' },
  [FIELDS.PROPERTY_NUMBER_OF_FLOORS_IN_THE_BUILDING]: {
    name: FIELDS.PROPERTY_NUMBER_OF_FLOORS_IN_THE_BUILDING,
    label: 'No. of floors in the building',
  },
  [FIELDS.PROPERTY_HAS_LIFT_ACCESS]: { name: FIELDS.PROPERTY_HAS_LIFT_ACCESS, label: 'Lift access' },
  [FIELDS.PROPERTY_TENURE_TYPE]: { name: FIELDS.PROPERTY_TENURE_TYPE, label: 'Tenure' },
  [FIELDS.PROPERTY_REMAINING_YEARS]: { name: FIELDS.PROPERTY_REMAINING_YEARS, label: 'Remaining term (years)' },
  [FIELDS.PROPERTY_IS_EX_LOCAL_AUTHORITY]: {
    name: FIELDS.PROPERTY_IS_EX_LOCAL_AUTHORITY,
    label: 'Ex-local authority',
  },
  [FIELDS.PROPERTY_IS_RETIREMENT_HOME]: {
    name: FIELDS.PROPERTY_IS_RETIREMENT_HOME,
    label: 'Retirement Home',
  },
  [FIELDS.PROPERTY_IS_RESTRICTED_COVENANT]: {
    name: FIELDS.PROPERTY_IS_RESTRICTED_COVENANT,
    label: 'Restricted Covenant',
  },
  [FIELDS.PROPERTY_IS_ABOVE_COMMERCIAL_PREMISES]: {
    name: FIELDS.PROPERTY_IS_ABOVE_COMMERCIAL_PREMISES,
    label: 'Above/adjacent commercial premises',
  },
  [FIELDS.PROPERTY_COMMERCIAL_PREMISES_DETAILS]: {
    name: FIELDS.PROPERTY_COMMERCIAL_PREMISES_DETAILS,
    label: 'Above commercial premises details',
  },
  [FIELDS.PROPERTY_HAS_COMMERCIAL_USAGE_ABOVE25_PERCENT]: {
    name: FIELDS.PROPERTY_HAS_COMMERCIAL_USAGE_ABOVE25_PERCENT,
    label: 'Commercial usage >25%',
  },
  [FIELDS.PROPERTY_COMMERCIAL_USAGE_DETAILS]: {
    name: FIELDS.PROPERTY_COMMERCIAL_USAGE_DETAILS,
    label: 'Commercial usage details',
  },
  [FIELDS.PROPERTY_NUMBER_OF_KITCHENS]: {
    name: FIELDS.PROPERTY_NUMBER_OF_KITCHENS,
    label: 'No. of Kitchens',
  },
  [FIELDS.PROPERTY_NUMBER_OF_BEDROOMS]: {
    name: FIELDS.PROPERTY_NUMBER_OF_BEDROOMS,
    label: 'No. of bedrooms',
  },
  [FIELDS.PROPERTY_HAS_AGRICULTURAL_RESTRICTIONS]: {
    name: FIELDS.PROPERTY_HAS_AGRICULTURAL_RESTRICTIONS,
    label: 'Agricultural restrictions',
  },
  [FIELDS.PROPERTY_PROPERTY_YEAR_BUILT]: {
    name: FIELDS.PROPERTY_PROPERTY_YEAR_BUILT,
    label: 'Year property was built',
  },
  [FIELDS.PROPERTY_WARRANTY_PROVIDER]: { name: FIELDS.PROPERTY_WARRANTY_PROVIDER, label: 'Warranty provider' },
  [FIELDS.PROPERTY_IS_PROPERTY_NEW_BUILD]: {
    name: FIELDS.PROPERTY_IS_PROPERTY_NEW_BUILD,
    label: 'Is the property a new build',
  },
  [FIELDS.PROPERTY_PROPERTY_CONSTRUCTION]: {
    name: FIELDS.PROPERTY_PROPERTY_CONSTRUCTION,
    label: 'Construction of property',
  },
  [FIELDS.PROPERTY_PROPERTY_DETAILS]: { name: FIELDS.PROPERTY_PROPERTY_DETAILS, label: 'Construction details' },
  [FIELDS.PROPERTY_INSTRUCTION_DATE]: { name: FIELDS.PROPERTY_INSTRUCTION_DATE, label: 'Instruction date' },
  [FIELDS.PROPERTY_INSPECTION_DATE]: { name: FIELDS.PROPERTY_INSPECTION_DATE, label: 'Inspection date' },
  [FIELDS.PROPERTY_VALUATION_TYPE]: { name: FIELDS.PROPERTY_VALUATION_TYPE, label: 'Type of valuation' },
  [FIELDS.PROPERTY_HAS_SPECIALIST_REPORT]: {
    name: FIELDS.PROPERTY_HAS_SPECIALIST_REPORT,
    label: 'Specialist report',
  },
  [FIELDS.PROPERTY_TITLE_NUMBER]: { name: FIELDS.PROPERTY_TITLE_NUMBER, label: 'Title Number' },
  [FIELDS.PROPERTY_ESTIMATED_PROPERTY_VALUE]: {
    name: FIELDS.PROPERTY_ESTIMATED_PROPERTY_VALUE,
    label: 'Estimated Property Value',
  },
  [FIELDS.PROPERTY_PROPERTY_PURCHASE_PRICE]: {
    name: FIELDS.PROPERTY_PROPERTY_PURCHASE_PRICE,
    label: 'Property Purchase Price',
  },
  [FIELDS.PROPERTY_ACTUAL_PROPERTY_VALUE]: {
    name: FIELDS.PROPERTY_ACTUAL_PROPERTY_VALUE,
    label: 'Actual Property Value',
  },
  [FIELDS.PROPERTY_OCCUPANTS_PREFIX]: (prefix: number) => ({
    [FIELDS.PROPERTY_OCCUPANT_FULLNAME]: {
      name: FIELDS.PROPERTY_OCCUPANT_FULLNAME,
      prefix: `${FIELDS.PROPERTY_OCCUPANTS_PREFIX}.${prefix}.`,
      label: 'Full name',
    },
    [FIELDS.PROPERTY_OCCUPANT_DATE_OF_BIRTH]: {
      name: FIELDS.PROPERTY_OCCUPANT_DATE_OF_BIRTH,
      prefix: `${FIELDS.PROPERTY_OCCUPANTS_PREFIX}.${prefix}.`,
      label: 'Date of birth',
    },
  }),
  [FIELDS.ASSURANCE_POLICIES_PREFIX]: (prefix: number) => ({
    [FIELDS.ASSURANCE_POLICY_EXPIRY_DATE]: {
      name: FIELDS.ASSURANCE_POLICY_EXPIRY_DATE,
      prefix: `${FIELDS.ASSURANCE_POLICIES_PREFIX}.${prefix}.`,
      label: 'Term expiry date',
    },
    [FIELDS.ASSURANCE_POLICY_ASSURED_PERSON]: {
      name: FIELDS.ASSURANCE_POLICY_ASSURED_PERSON,
      prefix: `${FIELDS.ASSURANCE_POLICIES_PREFIX}.${prefix}.`,
      label: 'Who is assured?',
    },
    [FIELDS.ASSURANCE_POLICY_TYPE]: {
      name: FIELDS.ASSURANCE_POLICY_TYPE,
      prefix: `${FIELDS.ASSURANCE_POLICIES_PREFIX}.${prefix}.`,
      label: 'Type of policy',
    },
    [FIELDS.ASSURANCE_POLICY_PAYMENTS_PER_ANNUM]: {
      name: FIELDS.ASSURANCE_POLICY_PAYMENTS_PER_ANNUM,
      prefix: `${FIELDS.ASSURANCE_POLICIES_PREFIX}.${prefix}.`,
      label: 'Payments to applicant per annum',
    },
    [FIELDS.ASSURANCE_POLICY_BASIS_OF_COVER]: {
      name: FIELDS.ASSURANCE_POLICY_BASIS_OF_COVER,
      prefix: `${FIELDS.ASSURANCE_POLICIES_PREFIX}.${prefix}.`,
      label: 'Basis of cover',
    },
    [FIELDS.ASSURANCE_POLICY_INSURANCE_LUMP_SUM]: {
      name: FIELDS.ASSURANCE_POLICY_INSURANCE_LUMP_SUM,
      prefix: `${FIELDS.ASSURANCE_POLICIES_PREFIX}.${prefix}.`,
      label: 'Life insurance lump sum',
    },
    [FIELDS.ASSURANCE_POLICY_MONTHLY_PAYMENT]: {
      name: FIELDS.ASSURANCE_POLICY_MONTHLY_PAYMENT,
      prefix: `${FIELDS.ASSURANCE_POLICIES_PREFIX}.${prefix}.`,
      label: 'Monthly premium',
    },
    [FIELDS.ASSURANCE_POLICY_MORTGAGE_MONTHLY_PAYMENTS]: {
      name: FIELDS.ASSURANCE_POLICY_MORTGAGE_MONTHLY_PAYMENTS,
      prefix: `${FIELDS.ASSURANCE_POLICIES_PREFIX}.${prefix}.`,
      label: 'Mortgage protection monthly payments',
    },
  }),
  [FIELDS.SOLICITOR_PREFIX]: () => ({
    [FIELDS.SOLICITOR_NAME]: {
      name: FIELDS.SOLICITOR_NAME,
      prefix: `${FIELDS.SOLICITOR_PREFIX}.`,
      label: 'Solicitor name',
    },
    [FIELDS.SOLICITOR_CONTACT_NUMBER]: {
      name: FIELDS.SOLICITOR_CONTACT_NUMBER,
      prefix: `${FIELDS.SOLICITOR_PREFIX}.`,
      label: 'Contact number',
    },
    [FIELDS.SOLICITOR_EMAIL]: {
      name: FIELDS.SOLICITOR_EMAIL,
      prefix: `${FIELDS.SOLICITOR_PREFIX}.`,
      label: 'Email address',
    },
    [FIELDS.SOLICITOR_FLAT_NUMBER]: {
      name: FIELDS.SOLICITOR_FLAT_NUMBER,
      prefix: `${FIELDS.SOLICITOR_PREFIX}.`,
      label: 'Flat Number',
    },
    [FIELDS.SOLICITOR_BUILDING_NUMBER]: {
      name: FIELDS.SOLICITOR_BUILDING_NUMBER,
      prefix: `${FIELDS.SOLICITOR_PREFIX}.`,
      label: 'Building Number',
    },
    [FIELDS.SOLICITOR_BUILDING_NAME]: {
      name: FIELDS.SOLICITOR_BUILDING_NAME,
      prefix: `${FIELDS.SOLICITOR_PREFIX}.`,
      label: 'Building Name',
    },
    [FIELDS.SOLICITOR_STREET]: {
      name: FIELDS.SOLICITOR_STREET,
      prefix: `${FIELDS.SOLICITOR_PREFIX}.`,
      label: 'Street',
    },
    [FIELDS.SOLICITOR_ADDRESS_CITY]: {
      name: FIELDS.SOLICITOR_ADDRESS_CITY,
      prefix: `${FIELDS.SOLICITOR_PREFIX}.`,
      label: 'City',
    },
    [FIELDS.SOLICITOR_ADDRESS_POSTCODE]: {
      name: FIELDS.SOLICITOR_ADDRESS_POSTCODE,
      prefix: `${FIELDS.SOLICITOR_PREFIX}.`,
      label: 'Postcode',
    },
  }),
  [FIELDS.FCA_LOAN_PURPOSE]: {
    name: FIELDS.FCA_LOAN_PURPOSE,
    label: 'FCA Loan Purpose',
  },
  [FIELDS.OUTSTANDING_MORTGAGE_AMOUNT]: {
    name: FIELDS.OUTSTANDING_MORTGAGE_AMOUNT,
    label: 'Current mortgage balance',
  },
  [FIELDS.SOURCE_OF_FUNDS_TO_CLEAR_OUTSTANDING_MORTGAGE]: {
    name: FIELDS.SOURCE_OF_FUNDS_TO_CLEAR_OUTSTANDING_MORTGAGE,
    label: 'Source of funds to clear outstanding mortgage',
  },
  [FIELDS.EXISTING_MORTGAGE_STATUS]: {
    name: FIELDS.EXISTING_MORTGAGE_STATUS,
    label: 'Existing Mortgage Status',
  },
  [FIELDS.APPLICANT_NUMBER_OF_DEPENDANTS]: {
    name: FIELDS.APPLICANT_NUMBER_OF_DEPENDANTS,
    label: 'No. of dependants',
  },
  [FIELDS.ANNUAL_COUNCIL_TAX]: {
    name: FIELDS.ANNUAL_COUNCIL_TAX,
    label: 'Annual council tax',
  },
  [FIELDS.ANNUAL_GROUND_RENT]: {
    name: FIELDS.ANNUAL_GROUND_RENT,
    label: 'Annual ground rent/service charge',
  },

  [FIELDS.ADMIN_PREFIX]: () => ({
    [FIELDS.ADMIN_OFFER_DATE]: {
      name: FIELDS.ADMIN_OFFER_DATE,
      prefix: `${FIELDS.ADMIN_PREFIX}.`,
      label: 'Offer Date',
    },
    [FIELDS.ADMIN_COT_REC_DATE]: {
      name: FIELDS.ADMIN_COT_REC_DATE,
      prefix: `${FIELDS.ADMIN_PREFIX}.`,
      label: 'CoT Rec’d Date',
    },
    [FIELDS.ADMIN_FUNDS_REQ_DATE]: {
      name: FIELDS.ADMIN_FUNDS_REQ_DATE,
      prefix: `${FIELDS.ADMIN_PREFIX}.`,
      label: 'Funds Req’d Date',
    },
    [FIELDS.ADMIN_EXPECTED_COMPLETION_DATE]: {
      name: FIELDS.ADMIN_EXPECTED_COMPLETION_DATE,
      prefix: `${FIELDS.ADMIN_PREFIX}.`,
      label: 'Expected Completion Date',
    },
    [FIELDS.ADMIN_COMPLETION_DATE]: {
      name: FIELDS.ADMIN_COMPLETION_DATE,
      prefix: `${FIELDS.ADMIN_PREFIX}.`,
      label: 'Completion Date',
    },
    [FIELDS.ADMIN_PEPPER_UPLOAD_DATE]: {
      name: FIELDS.ADMIN_PEPPER_UPLOAD_DATE,
      prefix: `${FIELDS.ADMIN_PREFIX}.`,
      label: 'Servicing Upload Date',
    },
    [FIELDS.ADMIN_PEPPER_ACCOUNT_ID]: {
      name: FIELDS.ADMIN_PEPPER_ACCOUNT_ID,
      prefix: `${FIELDS.ADMIN_PREFIX}.`,
      label: 'Servicing Account ID #',
    },
    [FIELDS.ADMIN_ORIGINATOR_ID]: {
      name: FIELDS.ADMIN_ORIGINATOR_ID,
      prefix: `${FIELDS.ADMIN_PREFIX}.`,
      label: 'Originator ID',
    },
    [FIELDS.ADMIN_DECLINE_DATE]: {
      name: FIELDS.ADMIN_DECLINE_DATE,
      prefix: `${FIELDS.ADMIN_PREFIX}.`,
      label: 'Decline Date',
    },
    [FIELDS.ADMIN_SWAP_COST]: {
      name: FIELDS.ADMIN_SWAP_COST,
      prefix: `${FIELDS.ADMIN_PREFIX}.`,
      label: 'Swap cost',
    },
    [FIELDS.ADMIN_EXPECTED_MATURITY]: {
      name: FIELDS.ADMIN_EXPECTED_MATURITY,
      prefix: `${FIELDS.ADMIN_PREFIX}.`,
      label: 'Projected Mortality ',
    },
  }),
  [FIELDS.DELEGATED_AUTHORITY_LEVEL]: {
    name: FIELDS.DELEGATED_AUTHORITY_LEVEL,
    label: 'Delegated Authority Level',
  },
  [FIELDS.INITIAL_ASSESSMENT_BY]: { name: FIELDS.INITIAL_ASSESSMENT_BY, label: 'Initial Assessment By' },
  [FIELDS.INITIAL_ASSESSMENT_APPROVED_BY]: {
    name: FIELDS.INITIAL_ASSESSMENT_APPROVED_BY,
    label: 'Approved By',
  },
  [FIELDS.INITIAL_ASSESSMENT_DATE]: { name: FIELDS.INITIAL_ASSESSMENT_DATE, label: 'Date' },
  [FIELDS.INITIAL_ASSESSMENT_APPROVED_DATE]: {
    name: FIELDS.INITIAL_ASSESSMENT_APPROVED_DATE,
    label: 'Date',
  },
  [FIELDS.UW_RECOMMENDATION]: { name: FIELDS.UW_RECOMMENDATION, label: 'Recommendation' },
  [FIELDS.UW_SPECIAL_CONDITIONS]: {
    name: FIELDS.UW_SPECIAL_CONDITIONS,
    label: 'Special conditions',
  },
  [FIELDS.AFT_PREFIX]: () => ({
    [FIELDS.AFT_STAGE]: {
      name: FIELDS.AFT_STAGE,
      label: 'Stage',
      prefix: `${FIELDS.AFT_PREFIX}.`,
    },
    [FIELDS.AFT_INCOME]: {
      name: FIELDS.AFT_INCOME,
      label: 'Income',
      prefix: `${FIELDS.AFT_PREFIX}.`,
    },
    [FIELDS.AFT_BUFFER]: {
      name: FIELDS.AFT_BUFFER,
      label: 'Buffer',
      prefix: `${FIELDS.AFT_PREFIX}.`,
    },
    [FIELDS.AFT_LIVING_COSTS]: {
      name: FIELDS.AFT_LIVING_COSTS,
      label: 'Living costs',
      prefix: `${FIELDS.AFT_PREFIX}.`,
    },
    [FIELDS.AFT_NET_CASH_FLOW]: {
      name: FIELDS.AFT_NET_CASH_FLOW,
      label: 'Net Cashflow',
      prefix: `${FIELDS.AFT_PREFIX}.`,
    },
    [FIELDS.AFT_MAX_LOAN_POSSIBLE]: {
      name: FIELDS.AFT_MAX_LOAN_POSSIBLE,
      label: 'Maximum Loan Possible',
      prefix: `${FIELDS.AFT_PREFIX}.`,
    },
  }),
};

export default fields;
